import { render, staticRenderFns } from "./TeamMateComponent.vue?vue&type=template&id=0a45db23&"
import script from "./TeamMateComponent.vue?vue&type=script&lang=ts&"
export * from "./TeamMateComponent.vue?vue&type=script&lang=ts&"
import style0 from "./TeamMateComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports